import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core';
import {ExcRestService} from 'exc-rest';
import {ExcSigninService} from 'exc-signin';
import {DomSanitizer} from '@angular/platform-browser';
import {SearchSlimData} from '../search-slim/search-slim.component';
import {ModalPlanningHqHelpComponent} from '../modals/modal-planning-hq-help/modal-planning-hq-help.component';
import {ModalPlanningHqWarningComponent} from '../modals/modal-planning-hq-warning/modal-planning-hq-warning.component';
import {ModalDealerEditComponent} from '../modals/modal-dealer-edit/modal-dealer-edit.component';
import {ExcTab} from 'exc-tab';
import {DealerDetailsComponent} from '../dealer-details/dealer-details.component';
import {ModalPlanningHqApprovalComponent} from '../modals/modal-planning-hq-approval/modal-planning-hq-approval.component';
import {ModalPlanningHqAuditDetailComponent} from '../modals/modal-planning-hq-audit-detail/modal-planning-hq-audit-detail.component';
import {$0} from 'codelyzer/angular/styles/chars';
import {DefaultSettingsService} from '../default-settings-service.service';
import {ModalPlanningHqSettingsComponent} from '../modals/modal-planning-hq-settings/modal-planning-hq-settings.component';
import {CurrencyPipe, DatePipe} from '@angular/common';
import {ClientModalAuditCancelComponent} from '../client/modals/client-modal-audit-cancel/client-modal-audit-cancel.component';


@Component({
  selector: 'app-planning-hq2-overview',
  templateUrl: './planning-hq2-overview.component.html',
  styles: []
})
export class PlanningHq2OverviewComponent extends ExcTranslation implements OnInit {

  @ViewChild('contextMenu') contextMenu;
  @ViewChild('trashMenu') trashMenu;
  @ViewChild('acceptWaitPanel') acceptWaitPanel;
  @ViewChild('mousecontext') mousecontext;
  @ViewChild('specialFiltersMenu') specialFiltersMenu;

  mandantID = null;
  trashMenuShown = false;
  mousecontextData = null;
  year = new Date().getFullYear();
  currentYear = new Date().getFullYear();
  currentMonth = new Date().getMonth() + 1;
  editMode = false;
  data: any[] = [];
  newAudits: any[] = [];
  movedAudits: any[] = [];
  deletedAudits: any[] = [];
  cancelledAudits: any[] = [];
  newAuditsProcessed = 0;
  movedAuditsProcessed = 0;
  deletedAuditsProcessed = 0;
  cancelledAuditsProcessed = 0;
  newAuditsFailed = 0;
  applyInProgress = false;
  pagingAactualPage = 1;
  pagingOldOffset;
  fcAnnounced = false;
  fcIncludeDoc = false;
  seletedAudits: any[] = [];
  dragged: {} = null;
  dataSort = {field: 'Haendlername', order: 'asc'};
  lastDragCol: string = null;
  lastDragElement: any = null;
  startDragElement: any = null;
  startDragCol: string = null;
  toDeleteElement: any = null;
  toDeleteCol: string = null;
  paintMode = 'SC';
  menuCol: string = null;
  paging: any;
  pagingInstace: any;
  isLoading = false;
  paginator: any[];
  searchFields = {};
  level = 1;
  specialFlt = {PlanningStatus: null};
  colMonthMatch = {
    Jan: 1, Feb: 2, Mar: 3, Apr: 4, May: 5, Jun: 6,
    Jul: 7, Aug: 8, Sep: 9, Oct: 10, Nov: 11, Dec: 12
  };
  selectedAudits = [];
  sum = {
    Sum01: 0, Sum02: 0, Sum03: 0, Sum04: 0, Sum05: 0, Sum06: 0,
    Sum07: 0, Sum08: 0, Sum09: 0, Sum10: 0, Sum11: 0, Sum12: 0,
    Sum13: 0, Sum14: 0, Sum15: 0, Sum16: 0, Sum17: 0, Sum18: 0,
    HierarchyEnabled: false
  };
  colorFC = {
    STORNO:     'rgba(255, 206, 86, 0.8)',   // weiches Gelb-Orange
    DONE:       'rgba(34, 177, 76, 0.8)',    // sattes Grün
    PLANNED:    'rgba(54, 162, 235, 0.8)',   // helleres Blau
    NOTCREATED: 'rgba(255, 99, 132, 0.8)',   // sanftes Korallenrot
    SELECTED:   'rgba(153, 102, 255, 0.8)',  // helles Lila
  };

  colorSC = {
    STORNO:     'rgba(255, 206, 86, 0.4)',
    DONE:       'rgba(34, 177, 76, 0.4)',    // gleiches sattes Grün
    PLANNED:    'rgba(54, 162, 235, 0.4)',
    NOTCREATED: 'rgba(255, 99, 132, 0.4)',
    SELECTED:   'rgba(153, 102, 255, 0.4)',
  };
  colorHighLevel = {
    CANCELLED: 'rgba(0, 247, 255, 0.5)',
    DONE: 'rgba(0, 247, 255, 0.5)',
    INPROG: 'rgba(0, 247, 255, 0.5)',
    EXPIRED: 'rgba(0, 247, 255, 0.5)',
    REJECTED: 'rgba(0, 247, 255, 0.5)',
    PLANNED: 'rgba(0, 247, 255, 0.5)',
    SELECTED: 'rgba(0, 247, 255, 0.5)',
    MOVETO: 'rgba(0, 247, 255, 0.5)',
    MOVEFROM: 'rgba(0, 247, 255, 0.5)',
    PLANNEDMOV: 'rgba(0, 247, 255, 0.5)'
  };
  levelIcons = {1: 'fa-user', 2: 'fa-user-tie', 3: 'fa-usere'};
  monthFlt = {month: null, mode: null};
  columnDefinition = {
    RRDI:         { span: 2, spanMin: 1, spanMax: 2, searchable: true, format: null },
    Verbund:      { span: 2, spanMin: 1, spanMax: 2, searchable: true, format: null },
    Steuernummer: { span: 3, spanMin: 1, spanMax: 4, searchable: true, format: null },
    Haendlername: { span: 5, spanMin: 1, spanMax: 6, searchable: true, format: null },
  };

  constructor(
    private excRest: ExcRestService,
    private cdr: ChangeDetectorRef,
    private sani: DomSanitizer,
    private excSec: ExcSigninService,
    private excDss: DefaultSettingsService,
    private datePipe: DatePipe,
    private currencyPipe: CurrencyPipe
  ) {
    super();
  }

  editDealer(x) {
    if (!this.excSec.isFeatured('CLI_DLR_CU')) {
      ExcCoreModule.showModal(this.getGlobal('RestrictedAccess'), this.getGlobal('RestrictedAccessHeader'), 's', {}, false, []).subscribe();
      return;
    }
    const _self = this;
    const urlDetails = _self.excRest.computeUrl('DealerR_Summary', {DealerID: x.DealerID});
    _self.excRest.get(urlDetails, {}).subscribe(retDetails => {
      if (retDetails && retDetails.data && retDetails.data.Header) {

        ExcCoreModule.showModal(ModalDealerEditComponent, null, 'm-alt', retDetails.data.Header, true).subscribe( r => {
          if (r && r.proceed === true) {
            r.dealer['DealerUPT'] = retDetails.data.Header['DealerUPT'];
            const url = _self.excRest.computeUrl('DealerU', {DealerID: x.DealerID});
            _self.excRest.post(url, r.dealer, {}).subscribe(ret => {
              Object.assign(x, ret.data.Header);
            });
          }
        });
      }
    });
  }
  setLevel(lvl) {
    if (this.applyInProgress === true) {
      return;
    }
    if (this.movedAudits.length > 0 || this.newAudits.length > 0
      || this.cancelledAudits.length > 0 || this.deletedAudits.length > 0) {
      ExcCoreModule.showModal(ModalPlanningHqWarningComponent, null, 's', { movedAudits: this.movedAudits.length, newAudits: this.newAudits.length, deletedAudits: this.deletedAudits.length, cancelledAudits: this.cancelledAudits.length }, false).subscribe(ret => {
        if (ret && ret.proceed === true) {
          this.level = lvl;
          this.newAudits = [];
          this.movedAudits = [];
          this.deletedAudits = [];
          this.cancelledAudits = [];
          if (lvl === 2) {
            delete this.searchFields['DealerLevel1'];
          }
          if (lvl === 3) {
            delete this.searchFields['DealerLevel2'];
          }
          this.reload(1, null);
        }
      });
    } else {
      this.level = lvl;
      if (lvl === 2) {
        delete this.searchFields['DealerLevel1'];
      }
      if (lvl === 3) {
        delete this.searchFields['DealerLevel2'];
      }
      this.reload(1, null);
    }
  }
  setMonthFlt(f) {
    this.monthFlt.month = this.colMonthMatch[this.menuCol];
    this.monthFlt.mode = f;
    this.reload(null, null);
  }
  getMonthHeaderClass(m) {
    if (this.monthFlt.month !== null && this.monthFlt.month === m && this.monthFlt.mode !== null) {
      return 'th-warning';
    }
    return 'th-secondary';
  }
  getMonthMenuActiveClass(m) {
    if (m === null && this.monthFlt.month !== this.colMonthMatch[this.menuCol]) {
      return 'th-warning';
    }
    if (this.monthFlt.month === this.colMonthMatch[this.menuCol] && this.monthFlt.mode === m) {
      return 'th-warning';
    }
    return 'th-secondary';
  }
  getTooltip(x, col) {
    let tt = '';
    for (const a of this.data) {
      if (a.DealerID === x.DealerID) {
        let audit = null;
        if (a[col].length > 0) {
          if (a[col].length > 1) {
            for (const _cm of a[col]) {
              if (_cm['auftr_art'] === 16 || _cm['auftr_art'] === 1) {
                audit = _cm;
                break;
              }
            }
            if (audit === null) {
              audit = a[col][0];
            }
          } else {
            audit = a[col][0];
          }
        }
        if (audit !== null && audit['IsOwnAudit'] === true && audit['auftr_art'] !== 16 ) {
          if (audit['stat'] === 'CANCELLED' && audit['Auftr_StornoGrund'] === 8) {
            tt = 'Floorcheck (' + this.getGlobal('AuditType_' + audit['auftr_art']) + ')\r\n' + this.getGlobal('Status') + ': ' + this.getRessource('STATE_CANCELLEDEXTERNAL');
          } else if (audit['stat'] === 'CANCELLED' && audit['Auftr_StornoGrund'] === 2) {
            tt = 'Floorcheck (' + this.getGlobal('AuditType_' + audit['auftr_art']) + ')\r\n' + this.getGlobal('Status') + ': ' + this.getRessource('STATE_CANCELLEDNOSTOCK');
          } else {
            tt = 'Floorcheck (' + this.getGlobal('AuditType_' + audit['auftr_art']) + ')\r\n' + this.getGlobal('Status') + ': ' + this.getRessource('STATE_' + audit['stat'])
              + '\r\n' + this.getGlobal('Announcement') + ': ' + (audit['auftr_ua'] === 1 ? this.getGlobal('No') : this.getGlobal('Yes'))
              + '\r\n' + this.getGlobal('Documents') + ': ' + (audit['Auftr_Brief'] === 1 ? this.getGlobal('No') : this.getGlobal('Yes'));
          }
        } else if (audit !== null && audit['auftr_art'] === 16) {
          if (audit['stat'] === 'CANCELLED' && audit['Auftr_StornoGrund'] === 8) {
            tt = 'Selfcheck\r\n' + this.getGlobal('Status') + ': ' + this.getRessource('STATE_CANCELLEDEXTERNAL');
          } else if (audit['stat'] === 'CANCELLED' && audit['Auftr_StornoGrund'] === 2) {
            tt = 'Selfcheck (' + this.getGlobal('AuditType_' + audit['auftr_art']) + ')\r\n' + this.getGlobal('Status') + ': ' + this.getRessource('STATE_CANCELLEDNOSTOCK');
          } else {
            tt = 'Selfcheck\r\n' + this.getGlobal('Status') + ': ' + this.getRessource('STATE_' + audit['stat']);
          }
        }
        if (audit !== null) {
          if (audit['AuditLevel'] !== 1) {
            tt = tt + '\r\n' + this.getGlobal('AuditOnHigherLevel');
          }
        }
        break;
      }
    }

    return tt;
  }
  getPrevAuditStyle(state) {
    let col = '#fff';
    if (state !== null) {
      col = this.colorFC[state];
    }
    return {
      backgroundColor: col,
      padding: '0.3rem',
      margin: '0.15rem',
      borderRadius: '4px'

    };
  }
  getMenuheader() {
    let txt = '';
    switch (this.menuCol) {
      case 'Jan': txt = '01'; break;
      case 'Feb': txt = '02'; break;
      case 'Mar': txt = '03'; break;
      case 'Apr': txt = '04'; break;
      case 'May': txt = '05'; break;
      case 'Jun': txt = '06'; break;
      case 'Jul': txt = '07'; break;
      case 'Aug': txt = '08'; break;
      case 'Sep': txt = '09'; break;
      case 'Oct': txt = '10'; break;
      case 'Nov': txt = '11'; break;
      case 'Dec': txt = '12'; break;
    }
    return txt + '/' + this.year;
  }
  monthExport()  {
    let txt = 0;
    switch (this.menuCol) {
      case 'Jan': txt = 1; break;
      case 'Feb': txt = 2; break;
      case 'Mar': txt = 3; break;
      case 'Apr': txt = 4; break;
      case 'May': txt = 5; break;
      case 'Jun': txt = 6; break;
      case 'Jul': txt = 7; break;
      case 'Aug': txt = 8; break;
      case 'Sep': txt = 9; break;
      case 'Oct': txt = 10; break;
      case 'Nov': txt = 11; break;
      case 'Dec': txt = 12; break;
    }
    const url = this.excRest.computeUrl('PlanningHQExportMonth', {AuditYear: this.year, AuditMonth: txt});
    window.location.href = url;
  }
  monthApproval()  {
    let txt = 0;
    switch (this.menuCol) {
      case 'Jan': txt = 1; break;
      case 'Feb': txt = 2; break;
      case 'Mar': txt = 3; break;
      case 'Apr': txt = 4; break;
      case 'May': txt = 5; break;
      case 'Jun': txt = 6; break;
      case 'Jul': txt = 7; break;
      case 'Aug': txt = 8; break;
      case 'Sep': txt = 9; break;
      case 'Oct': txt = 10; break;
      case 'Nov': txt = 11; break;
      case 'Dec': txt = 12; break;
    }
    const _self = this;
    const url = this.excRest.computeUrl('PlanningHQMonthApproval', {AuditYear: this.year, AuditMonth: txt});
    this.excRest.get(url, {Language: _self.translateService.currentLang}).subscribe(ret => {
      ExcCoreModule.showModal(ModalPlanningHqApprovalComponent, null, 's', ret.data[0], false, null).subscribe();
    });
    this.contextMenu.hide();
  }
  getMenubodytext() {
    let cnt = 0;
    for (const x of this.newAudits) {
      if (x['Col'] === this.menuCol) {
        cnt = cnt + 1;
      }
    }
    if (cnt === 0) {
      return 'Keine Änderungen vorgenommen';
    } else if (cnt === 1) {
      return 'Ein neues Audit';
    } else if (cnt > 1) {
      return cnt + ' neue Audits';
    }
  }
  getMonthIconClass(pref, x, col) {
    let clr = '';

    const scLevel = x[pref + col + 'SCLevel'];
    const fcLevel = x[pref + col + 'FCLevel'];
    if (scLevel !== null ) {
      clr = this.levelIcons[scLevel];
    } else {
    }
    if (fcLevel !== null ) {
      clr = this.levelIcons[fcLevel];
    }
    return clr;
  }
  getMonthStyle(isPrimary, pref, x, col) {
    let clr = isPrimary ? '#fff' : '#ddd';

    if (x[col].includes('SC')) {
      const SCState = x[col].replace('SC', '');

      clr = this.colorSC[SCState];
    } else if (x[col].includes('FC')) {
      const FCState = x[col].replace('FC', '');

      clr = this.colorFC[FCState];
    }

    const padding = '0.5rem';
    // let padding = '';
    // if (fcstatus === null && scstatus === null) {
    //   padding = '0.5rem';
    // } else {
    //   if (scstatus !== 'SELECTED' || scstatus !== 'SELECTED') {
    //     padding = '';
    //   } else {
    //     padding = '0.5rem';
    //   }
    // }

    return {
      cursor: 'default',
      backgroundColor: clr,
      userSelect: 'none'
      , paddingRight: 0
      , paddingBottom: 0

    };
  }
  showContextMenu(event, x, col) {
    if (this.excSec.isFeatured('CLI_ADT_U')) {
      if (x[col].length === 1) {
        event.preventDefault();
        this.mousecontextData = x[col][0];
        this.mousecontext.show(event);
      }
    }
    event.stopPropagation();
    event.cancelBubble = true;
    return false;
  }
  showContextMenuAudits(event, x) {
    event.preventDefault();
    this.mousecontextData = x;
    this.mousecontext.show(event);
    event.stopPropagation();
    event.cancelBubble = true;
    return false;
  }
  ShowContextDetails() {
    this.mousecontext.hide();
    ExcCoreModule.showModal(ModalPlanningHqAuditDetailComponent, null, 'm', this.mousecontextData,  false).subscribe(ret => {
      if (ret && ret.proceed === true) {
        this.excRest.post(this.excRest.computeUrl('PlanningHQAuditU_Edit',
            {AuditYear: this.currentYear, AuditID: this.mousecontextData['auftr_id']}),
          {auftr_ua: ret.data['auftr_ua'], auftr_brief: ret.data['Auftr_Brief']}, {}).subscribe(r => {
          this.mousecontextData['auftr_ua'] = ret.data['auftr_ua'];
          this.mousecontextData['Auftr_Brief'] = ret.data['Auftr_Brief'];
        });
      }
    });
  }
  isDragable(x, col)
  {
    let isDrag = false;
    if (this.editMode === true && x[col].length === 1 && x[col][0])
    {
      if (this.year < this.currentYear)
      {
        return false;
      }
      // if (x[col][0].IsOwnAudit === false) {
      //   return false;
      // }
      if (this.year === this.currentYear)
      {
        if (this.colMonthMatch[col] < this.currentMonth)
        {
          return false;
        }
      }
      if (x[col][0]['stat'] === 'SELECTED')
      {
        return false;
      }
      if (x[col][0]['stat'] !== 'PLANNED')
      {
        return false;
      }
      if (this.paintMode === 'SC' && x[col][0]['auftr_art'] === 16)
      {
        isDrag = true;
      }
      else if (this.paintMode === 'FC' && x[col][0]['auftr_art'] !== 16)
      {
        isDrag = true;
      }
      // isDrag = x[col + this.paintMode + 'Status'] === 'PLANNED';
    }
    return isDrag;
  }
  dragStart(x, col, event) {
    if (this.isDragable(x, col)) {
      this.dragged = {obj: x, col: col, evt: event};
      event.dataTransfer.effectAllowed = 'move';
      this.startDragCol = col;
      this.startDragElement = event.srcElement;
    } else {
      event.preventDefault();
    }
  }
  dragEnter(x, col, event) {
    if (x.DealerID === this.dragged['obj'].DealerID && (this.year > this.currentYear || (this.year === this.currentYear && this.colMonthMatch[col] >= this.currentMonth))) {
      // if (x[+ col + 'FCStatus'] === null && x['CurrentYear' + col + 'SCStatus'] === null) {
      if (x[col].length === 0) {
        event.srcElement.style.backgroundColor = 'rgba(56, 255, 235, 0.3)';
        this.lastDragCol = col;
        this.lastDragElement = event.srcElement;
      } else {
        this.lastDragCol = null;
        this.lastDragElement = null;
      }
    } else {
      this.lastDragCol = null;
      this.lastDragElement = null;
    }
    event.preventDefault();
  }
  dragLeave(x, col, event) {
    if (x.DealerID === this.dragged['obj'].DealerID) {
      // if (x['CurrentYear' + col + 'FCStatus'] === null && x['CurrentYear' + col + 'SCStatus'] === null) {
      if (x[col].length === 0) {
        event.srcElement.style.backgroundColor = '#ffffff';
      }
    }
  }
  dragEnd(x, col, event) {
    if (x.DealerID === this.dragged['obj'].DealerID && this.lastDragCol !== null && (this.year > this.currentYear || (this.year === this.currentYear && this.colMonthMatch[col] >= this.currentMonth))) {
      // if (x['CurrentYear' + this.lastDragCol + 'FCStatus'] === null && x['CurrentYear' + this.lastDragCol + 'SCStatus'] === null) {
      if (x[this.lastDragCol].length === 0) {
        const no = {};
        Object.assign(no, this.dragged['obj'][this.startDragCol][0]);
        no['moveTo'] = true;
        no['stat'] = 'MOVETO';
        x[this.lastDragCol].push(no);
        // x[this.lastDragCol + this.paintMode + 'Status'] = 'MOVETO';
        this.dragged['obj'][this.startDragCol][0].moveFrom = true; // + this.paintMode + 'Status'] = 'MOVEFROM';
        this.lastDragElement.style.backgroundColor = this['color' + this.paintMode]['MOVETO'];
        this.startDragElement.style.backgroundColor = this['color' + this.paintMode]['MOVEFROM'];
        this.movedAudits.push({DealerID: x.DealerID, Mode: this.editMode, From: this.startDragCol, To: this.lastDragCol, AuditID:  no['auftr_id']});
      }
    }
    this.lastDragCol = null;
    this.lastDragElement = null;
    this.startDragElement = null;
    this.startDragCol = null;
    event.preventDefault();
  }
  dragOver(x, col, event) {
    event.preventDefault();
  }
  showTrashMenu(event) {
    if (!this.excSec.isFeatured('CLI_ADT_D')) {
      return;
    }
    this.toDeleteElement = this.startDragElement;
    this.toDeleteCol = this.startDragCol;
    this.trashMenu.show(event);
  }

  trashActionDelete() {
    if (!this.excSec.isFeatured('CLI_ADT_D')) {
      ExcCoreModule.showModal(this.getGlobal('RestrictedAccess'), this.getGlobal('RestrictedAccessHeader'), 's', {}, false, []).subscribe();
      return;
    }
    this.trashMenuShown = false;
    this.trashMenu.hide();
    this.toDeleteElement.style.backgroundColor  = '#ffffff';
    this.deletedAudits.push({DealerID: this.dragged['obj']['DealerID'], Mode: this.paintMode, Col: this.toDeleteCol, AuditID:  this.dragged['obj'][this.toDeleteCol][0]['auftr_id']});
    this.dragged['obj'][this.toDeleteCol] = []; // + this.paintMode + 'Status'] = null;
    this.toDeleteCol = null;
    this.toDeleteElement = null;
  }
  trashActionCancel() {
    if (!this.excSec.isFeatured('CLI_ADT_D')) {
      ExcCoreModule.showModal(this.getGlobal('RestrictedAccess'), this.getGlobal('RestrictedAccessHeader'), 's', {}, false, []).subscribe();
      return;
    }
    this.trashMenuShown = false;
    this.trashMenu.hide();
    ExcCoreModule.showModal(ClientModalAuditCancelComponent, null, 'm', {}, false, null).subscribe( ret => {
      if (ret && ret.proceed === true) {
        this.toDeleteElement.style.backgroundColor  = this['color' + this.paintMode]['CANCELLED'];
        this.cancelledAudits.push({DealerID: this.dragged['obj']['DealerID'], Mode: this.paintMode, Col: this.toDeleteCol, AuditID:  this.dragged['obj'][this.toDeleteCol][0]['auftr_id'],
          CancellationReason: ret.CancellationReason, Comment: ret.Comment});
        this.dragged['obj'][this.toDeleteCol][0]['auftr_status'] = 10;
        this.toDeleteCol = null;
        this.toDeleteElement = null;
      }
    });


  }
  showMonthContext(col, event) {
    // if (this.editMode === true) {
    this.menuCol = col;
    this.contextMenu.show(event);
    // }
  }

  handleMouseClick(x, col, event) {
    if (this.editMode === true && event.buttons === 1 ) {
      if (((x['CurrentYear' + col + 'SCStatus'] !== null && x['CurrentYear' + col + 'SCStatus'] !== 'SELECTED') || (x['CurrentYear' + col + 'FCStatus'] !== null && x['CurrentYear' + col + 'FCStatus'] !== 'SELECTED'))  && (this.year < this.currentYear || (this.year === this.currentYear && this.colMonthMatch[col] > this.currentMonth))) {
        return;
      }
      if (this.year < this.currentYear) {
        return;
      }
      if (this.year === this.currentYear) {
        if (this.currentMonth[col] <= this.currentMonth) {
          return;
        }
      }

      const fcSet = x['CurrentYear' + col + 'FCStatus'] !== null;
      const scSet = x['CurrentYear' + col + 'SCStatus'] !== null;

      if (this.paintMode === 'SC') {
        if (fcSet) {
          return;
        }
        if (scSet) {
          x['CurrentYear' + col + 'SCStatus'] = null;
          event.srcElement.style['backgroundColor'] = '#FFFFFF';
          this.newAudits = this.newAudits.filter((a) => {
            return !(a.DealerID === x.DealerID && a.Mode === this.paintMode && a.Col === col);
          });
        } else {
          x['CurrentYear' + col + 'SCStatus'] = 'SELECTED';
          event.srcElement.style['backgroundColor'] = this.colorSC.SELECTED;
          this.newAudits.push({DealerID: x.DealerID, Mode: this.paintMode, Col: col });
        }
      } else if (this.paintMode === 'FC') {
        if (scSet) {
          return;
        }
        if (fcSet) {
          x['CurrentYear' + col + 'FCStatus'] = null;
          event.srcElement.style['backgroundColor'] = '#FFFFFF';
          this.newAudits = this.newAudits.filter((a) => {
            return !(a.DealerID === x.DealerID && a.Mode === this.paintMode && a.Col === col);
          });
        } else {
          x['CurrentYear' + col + 'FCStatus'] = 'SELECTED';
          event.srcElement.style['backgroundColor'] = this.colorFC.SELECTED;
          this.newAudits.push({DealerID: x.DealerID, Mode: this.paintMode, Col: col });
        }
      }
    }
  }

  handleMouseEnter(x, col, event) {
    // if (event.buttons === 2) {
    //   if (x[col].length === 1) {
    //     event.preventDefault();
    //     this.mousecontextData = x[col];
    //     this.mousecontext.show(event);
    //   }
    //   return;
    // }
    if (this.editMode === true && event.buttons === 1 ) {
      if (this.startDragCol !== null) {
        return;
      }
      if ((this.year < this.currentYear || (this.year === this.currentYear && this.colMonthMatch[col] < this.currentMonth))) {
        return;
      }
      if (x[col].length > 1) {
        return;
      }
      if (x[col].length === 1) {
        if (x[col][0]['newAudit'] === true && ((x[col][0]['auftr_art'] === 16 && this.paintMode === 'SC' ) || (x[col][0]['auftr_art'] !== 16 && this.paintMode === 'FC'))) {
          x[col].splice(0, 1);
          this.newAudits = this.newAudits.filter((a) => {
            return !(a.DealerID === x.DealerID && a.Mode === this.paintMode && a.Col === col);
          });
        }
      } else {
        x[col].push({
          newAudit: true,
          DealerID: x.DealerID,
          auftr_art: this.paintMode === 'SC' ? 16 : 1,
          auftr_status: 1,
          stat: 'SELECTED',
          auftr_ua:  (this.fcAnnounced === true ? 0 : 1),
          Auftr_Brief: this.fcIncludeDoc === true ? 21 : 1
        });

        this.newAudits.push({
          DealerID: x.DealerID,
          Mode: this.paintMode,
          Col: col,
          Lvl: this.level,
          Auftr_ua: (this.fcAnnounced === true ? 0 : 1),
          Auftr_Brief: this.fcIncludeDoc === true ? 21 : 1
        });


        // if (this.paintMode === 'SC') {
        //   event.srcElement.style['backgroundColor'] = this.colorSC.SELECTED;
        // } else {
        //   event.srcElement.style['backgroundColor'] = this.colorFC.SELECTED;
        // }
      }
      //
      // const fcSet = x['CurrentYear' + col + 'FCStatus'] !== null;
      // const scSet = x['CurrentYear' + col + 'SCStatus'] !== null;
      //
      // if (this.paintMode === 'SC') {
      //   if (fcSet) {
      //     return;
      //   }
      //   if (scSet) {
      //     x['CurrentYear' + col + 'SCStatus'] = null;
      //     event.srcElement.style['backgroundColor'] = '#FFFFFF';
      //     this.newAudits = this.newAudits.filter((a) => {
      //       return !(a.DealerID === x.DealerID && a.Mode === this.paintMode && a.Col === col);
      //     });
      //   } else {
      //     x['CurrentYear' + col + 'SCStatus'] = 'SELECTED';
      //     event.srcElement.style['backgroundColor'] = this.colorSC.SELECTED;
      //     this.newAudits.push({DealerID: x.DealerID, Mode: this.paintMode, Col: col, Lvl: this.level });
      //   }
      // } else if (this.paintMode === 'FC') {
      //   if (scSet) {
      //     return;
      //   }
      //   if (fcSet) {
      //     x['CurrentYear' + col + 'FCStatus'] = null;
      //     event.srcElement.style['backgroundColor'] = '#FFFFFF';
      //     this.newAudits = this.newAudits.filter((a) => {
      //       return !(a.DealerID === x.DealerID && a.Mode === this.paintMode && a.Col === col);
      //     });
      //   } else {
      //     x['CurrentYear' + col + 'FCStatus'] = 'SELECTED';
      //     event.srcElement.style['backgroundColor'] = this.colorFC.SELECTED;
      //     this.newAudits.push({DealerID: x.DealerID, Mode: this.paintMode, Col: col, Lvl: this.level});
      //   }
      // }
    }
  }
  handleMouseUp(event) {
    // if (event.buttons === 1) {
    //   alert(this.newAudits.length + ' to plan');
    // }
  }

  getSortClass(f) {
    if (this.dataSort.field === f) {
      if (this.dataSort.order === 'asc') {
        return 'fa-sort-up';
      } else {
        return 'fa-sort-down';
      }
    } else {
      return 'fa-sort';
    }
  }
  setSort (f) {
    if (this.dataSort.field === f) {
      if (this.dataSort.order === 'asc') {
        this.dataSort.order = 'desc';
      } else {
        delete this.dataSort.field;
      }
    } else {
      this.dataSort.field = f;
      this.dataSort.order = 'asc';
    }
    this.reload(1, null);
  }
  searchChanged(v: SearchSlimData) {
    if (v.value === null || v.value === '') {
      delete this.searchFields[v.field];
    } else {
      this.searchFields[v.field] = v.value;
    }
    this.reload(1, null);
  }
  showHelp() {
    ExcCoreModule.showModal(ModalPlanningHqHelpComponent, null, 'l', null,  true).subscribe(ret => {});
  }
  initialLoad() {
    if (this.applyInProgress === true) {
      return;
    }
    const _self = this;
    const metainfo = {
      dataFilter: {},
      dataSort: {},
      dataPaging: {pageNo: 1, pageSize: 17}
    };
    metainfo.dataSort[this.dataSort.field] = this.dataSort.order;
    this.isLoading = true;
    let url = '';
    if (this.monthFlt.mode !== null) {
      url = _self.excRest.computeUrl('PlanningHQ2_SFS_R_Summary', {AuditYear: _self.year, monthFlt: _self.monthFlt.month, monthInc: _self.monthFlt.mode});
    } else {
      url = _self.excRest.computeUrl('PlanningHQ2_SFS_R_Summary', {AuditYear: _self.year});
    }
    _self.excRest.get(url, {MetaInfo: metainfo}).subscribe(ret => {

      if (ret && ret.success) {
        _self.data = ret.data.List;
        _self.sum = ret.data.Summary;
      }
      _self.paging = ret.paging.List ;
      this.isLoading = false;
    });
  }
  exportData() {
    const _self = this;
    const url = this.excRest.computeUrl('PlanningHQExport', {AuditYear: this.year, cult: _self.translateService.currentLang});
    window.location.href = url;
  }
  showDealerDetails(x) {
    new ExcTab(x.Haendlername, DealerDetailsComponent, x, x.DealerID, {
      Unique: true, ReloadParent: function () {
      }
    }, true).Open();
  }
  applyChanges(e) {
    if (!this.excSec.isFeatured('AUDITC')) {
      ExcCoreModule.showModal(this.getGlobal('RestrictedAccess'), this.getGlobal('RestrictedAccessHeader'), 's', {}, false, []).subscribe();
      return;
    }
    if (this.newAudits.length === 0 && this.movedAudits.length === 0 && this.cancelledAudits.length === 0 && this.deletedAudits.length === 0) {
      return;
    }
    this.newAuditsProcessed = 0;
    this.movedAuditsProcessed = 0;
    this.deletedAuditsProcessed = 0;
    this.cancelledAuditsProcessed = 0;
    this.newAuditsFailed = 0;
    this.applyInProgress = true;
    this.acceptWaitPanel.show(e);
    this.processNextNewAudit();
    this.processNextMovedAudit();
    this.processNextDeletedAudit();
    this.processNextCancelledAudit();
  }

  processNextNewAudit() {
    const _self = this;
    if (_self.newAudits.length === 0 || _self.newAuditsProcessed  === _self.newAudits.length) {
      return;
    }
    const a = _self.newAudits[_self.newAuditsProcessed];
    const o = {
      DealerID: a.DealerID,
      AuditMonth: _self.colMonthMatch[a.Col],
      AuditLevel: _self.level,
      Mode: a.Mode.toUpperCase(),
      Auftr_Brief: this.fcIncludeDoc === true ? 21 : 1,
      Auftr_ua: this.fcAnnounced === true ? 0 : 1

    };
    const url = _self.excRest.computeUrl('PlanningHQAuditC', {AuditYear: _self.year});
    _self.excRest._putInternal(url, o , {} , true).subscribe(ret => {
      if (ret && ret.rtval === 1000) {
        _self.newAuditsProcessed = _self.newAuditsProcessed + 1;
      } else if (ret && ret.rtval !== 1000) {
        _self.newAuditsProcessed = _self.newAuditsProcessed + 1;
        _self.newAuditsFailed = _self.newAuditsFailed + 1;
      }
      _self.checkProgress();
      _self.processNextNewAudit();
    });
  }

  processNextMovedAudit() {
    const _self = this;
    if (_self.movedAudits.length === 0 || _self.movedAuditsProcessed  === _self.movedAudits.length) {
      return;
    }
    const a = _self.movedAudits[_self.movedAuditsProcessed];
    const o = {
      AuditMonth: _self.colMonthMatch[a.To]
    };
    const url = _self.excRest.computeUrl('PlanningHQAuditU_Move', {AuditYear: _self.year, AuditID: a.AuditID});
    _self.excRest._postInternal(url, o , {}, true ).subscribe(ret => {
      if (ret && ret.rtval === 1000) {
        _self.movedAuditsProcessed = _self.movedAuditsProcessed + 1;
      }
      _self.checkProgress();
      _self.processNextMovedAudit();
    });
  }

  processNextCancelledAudit() {
    const _self = this;
    if (_self.cancelledAudits.length === 0 || _self.cancelledAuditsProcessed  === _self.cancelledAudits.length) {
      return;
    }
    const a = _self.cancelledAudits[_self.cancelledAuditsProcessed];
    const url = _self.excRest.computeUrl('PlanningHQAuditU_Cancel', {AuditYear: _self.year, AuditID: a.AuditID});
    _self.excRest._postInternal(url, {CancellationReason: a.CancellationReason, Comment: a.Comment } , {}, true ).subscribe(ret => {
      if (ret && ret.rtval === 1000) {
        _self.cancelledAuditsProcessed = _self.cancelledAuditsProcessed + 1;
      }
      _self.checkProgress();
      _self.processNextCancelledAudit();
    });
  }

  processNextDeletedAudit() {
    const _self = this;
    if (_self.deletedAudits.length === 0 || _self.deletedAuditsProcessed  === _self.deletedAudits.length) {
      return;
    }
    const a = _self.deletedAudits[_self.deletedAuditsProcessed];
    const url = _self.excRest.computeUrl('PlanningHQAuditD', {AuditYear: _self.year, AuditID: a.AuditID});
    _self.excRest._deleteInternal(url, {} , {} , true).subscribe(ret => {
      if (ret && ret.rtval === 1000) {
        _self.deletedAuditsProcessed = _self.deletedAuditsProcessed + 1;
      }
      _self.checkProgress();
      _self.processNextDeletedAudit();
    });
  }
  closeApplyWindow() {
    this.acceptWaitPanel.hide();
    this.applyInProgress = false;
    this.newAuditsProcessed = 0;
    this.movedAuditsProcessed = 0;
    this.deletedAuditsProcessed = 0;
    this.cancelledAuditsProcessed = 0;
    this.newAudits = [];
    this.movedAudits = [];
    this.deletedAudits =  [];
    this.cancelledAudits = [];
    this.reload(this.paging.pagingPage, null);

  }
  checkProgress() {
    if (this.applyInProgress) {
      if (this.movedAudits.length === this.movedAuditsProcessed
        && this.newAudits.length === this.newAuditsProcessed
        && this.deletedAudits.length === this.deletedAuditsProcessed
        && this.cancelledAudits.length === this.cancelledAuditsProcessed) {
        this.reload(this.paging.pagingPage, null);
      } else {
        this.applyInProgress = true;
      }
    }
  }
  getColHeaderClass(col, idx, first) {
    const cls = [];
    cls.push('cell');
    if (idx === 0) {
      cls.push('list-fake');
    }
    if (col.span > 1) {
      cls.push('span-' + col.span);
    }
    return cls;
  }
  getColClass(col, idx, first) {
    const cls = [];
    // cls.push('cell');
    // if (idx === 0) {
    //   cls.push('list-fake');
    // }
    if (col.span > 1) {
      cls.push('span-' + col.span);
    }
    return cls;
  }
  getHeaderFillClass() {
    let sum = 12;
    for (const c of this.excDss.UserSettings['PHQColumns_SFS']) {
      sum -= c.span;
    }
    return sum > 0 ? 'span-' + sum : '';
  }
  getCellValue(row, col) {
    if (this.columnDefinition[col.col]['format'] === null) {
      return row[col.col];
    }
    if (this.columnDefinition[col.col]['format'] === 'money') {
      return row[col.col];
    } else {
      return this.datePipe.transform(row[col.col], this.getGlobal(this.columnDefinition[col.col]['format']));
    }
  }
  showSettings() {
    const _self = this;
    ExcCoreModule.showModal(ModalPlanningHqSettingsComponent, null, 'xl', {def: _self.columnDefinition}, false).subscribe( r => {
      if (r && r.proceed === true) {
        const sn = [];
        for (let i = 0; i < r.settingsNew.length; i++) {
          if (r.settingsNew[i].col !== null) {
            sn.push({col: r.settingsNew[i].col, span: r.settingsNew[i].span});
          }
        }
        _self.excDss.UserSettings['PHQColumns_SFS'] = sn;
        _self.excDss.Update();
      }
    });

  }
  reload(pageNo, event) {
    if (this.applyInProgress === true) {
      return;
    }
    const _self = this;
    this.paging.pagingPage = pageNo;
    const metainfo = {
      dataFilter: {},
      dataSort: {},
      dataPaging: {pageNo: pageNo, pageSize: 17}
    };
    if (this.specialFlt.PlanningStatus !== null) {
      if (this.specialFlt.PlanningStatus === 'Unequal') {
        metainfo.dataFilter['PlanningStatus'] = ['Below', 'Above'];
      } else {
        metainfo.dataFilter['PlanningStatus'] = this.specialFlt.PlanningStatus;

      }
    }
    this.isLoading = true;
    metainfo.dataSort[this.dataSort.field] = this.dataSort.order;
    for (const k of Object.keys(this.searchFields)) {
      // metainfo.dataFilter[k] = {value: this.searchFields[k], operator: 'LIKE'};
      metainfo.dataFilter[k] = this.searchFields[k];
    }
    let url = '';
    if (this.monthFlt.mode !== null) {
      url = _self.excRest.computeUrl('PlanningHQ2_SFS_R_Summary', {AuditYear: _self.year, level: _self.level, monthFlt: _self.monthFlt.month, monthInc: _self.monthFlt.mode});
    } else {
      url = _self.excRest.computeUrl('PlanningHQ2_SFS_R_Summary', {AuditYear: _self.year, level: _self.level});
    }

    _self.excRest.get(url, {MetaInfo: metainfo}).subscribe(ret => {
      if (ret && ret.success) {
        _self.data = ret.data.List;
        _self.sum = ret.data.Summary;
        // _self.mandantID = ret.data.Summary.MandantID;
      }
      _self.paging = ret.paging.List ;
      this.isLoading = false;
    });
  }


  ngOnInit() {

    // this.applyHeaderLabels();
    // --- NUR Labels setzen, KEINE Keys umbenennen ---
    // @ts-ignore
    // nur diese 5 links anzeigen
    (this.excDss as any).UserSettings = (this.excDss as any).UserSettings || {};
    this.initialLoad();
    // --- OPTIONAL: "Letzte Audits" aus der Ansicht entfernen ---
    // -> auskommentieren, wenn du die Spalte wie in Bild 1 sichtbar haben willst
    // if (this.excDss.UserSettings.PHQColumns_SFS) {
    //   this.excDss.UserSettings.PHQColumns_SFS = this.excDss.UserSettings.PHQColumns_SFS
    //     .filter(c => c.col !== 'LastAudits');
    // }

    // console.log('PHQColumns_SFS:', this.excDss.UserSettings.PHQColumns_SFS);
    // console.log('Labels:', this.excDss.MandantSettings.Labels);

    // ===== dein bisheriger Code darunter unverändert =====
    // console.log('neues newAuditsProcessed -> '+this.newAuditsProcessed)
    // console.log('neues Audit -> '+this.newAudits)
    // console.log('neues startDragCol -> '+this.startDragCol)
  }


  // private applyHeaderLabels(): void {
  //   // Stelle sicher, dass das Objekt existiert
  //   this.excDss.MandantSettings = this.excDss.MandantSettings || {};
  //   this.excDss.MandantSettings.Labels = {
  //     ...(this.excDss.MandantSettings.Labels || {}),
  //
  //     DealerLevel1: 'RRDI',
  //     DealerLevel2: 'Verbund',
  //     DealerLevel3: 'Steuernummer',
  //     DealerName:   'Haendlername'
  //   };
  //
  // }

  getAvatarClass(x) {
    if (x.auftr_art === 16) {
      if (x.Auftr_IsPicked) {
        return 'fa-mobile th-warning';
      } else {
        return 'fa-mobile th-secondary';
      }
    } else {
      if (x.Auftr_IsPicked) {
        return 'fa-user-secret th-warning';
      } else {
        return 'fa-user-secret th-secondary';
      }
    }
  }
  getAttractorTip(x) {
    if (x.auftr_art === 16) {
      switch (x.auftr_status) {
        case 1:
        case 2:
        case 3:
          return this.getGlobal('Planned');
          break;
        case 8:
        case 9:
          if (x.ScRejected === true) {
            return this.getGlobal('Rejected');
          } else {
            if (x.ScEnded === true) {
              return this.getGlobal('Done');
            } else {
              return this.getGlobal('Expired');
            }
          }
          break;
        case 10:
          return this.getGlobal('Cancelled');
          break;
      }
    } else {
      switch (x.auftr_status) {
        case 1:
        case 2:
        case 3:
          return this.getGlobal('Planned');
          break;
        case 4:
        case 5:
        case 6:
        case 7:
          return this.getGlobal('InProgress');
          break;
        case 8:
        case 9:
          return this.getGlobal('Done');
          break;
        case 10:
          return this.getGlobal('Cancelled');
          break;
      }
    }
  }
  getKSPClass(x) {
    let s = 0;
    for (const k of Object.keys(this.colMonthMatch)) {
      for (let i = 0; i < x[k].length; i++) {
        if (x[k][i].auftr_status !== 10) {
          s = s + 1;
        }
      }
    }
    if (s < x.AuditsPerYear) {
      return ['th-bold', 'th-danger'];
    }
    return [];
  }
  getAttractorClass(x) {
    if (x.auftr_art === 16) {
      switch (x.auftr_status) {
        case 1:
        case 2:
        case 3:
          return 'ch-secondary fa-calendar';
          break;
        case 8:
        case 9:
          if (x.ScRejected === true) {
            return 'ch-danger fa-exclamation';
          } else {
            if (x.ScEnded === true) {
              return 'ch-success fa-check';
            } else {
              return 'ch-warning fa-clock';
            }
          }
          break;
        case 10:
          return 'ch-warning fa-ban';
          break;
      }
    } else {
      switch (x.auftr_status) {
        case 1:
        case 2:
        case 3:
          return 'ch-secondary fa-calendar';
          break;
        case 4:
        case 5:
        case 6:
        case 7:
          return 'ch-secondary fa-cogs';
          break;
        case 8:
        case 9:
          return 'ch-success fa-check';
          break;
        case 10:
          return 'ch-warning fa-ban';
          break;
      }
    }
  }
  applySpecial() {
    this.specialFiltersMenu.hide();
    this.reload(this.paging.pagingPage, null);
  }
  resetSpecial() {
    this.specialFlt.PlanningStatus = null;
    this.reload(this.paging.pagingPage, null);
    this.specialFiltersMenu.hide();
  }
  showSpecialFilters(event) {
    this.specialFiltersMenu.show(event);
  }
  GetPaginator(length?, element?): string[] {
    let reRender = false;
    if (element) {
      if (element.offsetWidth > 1000) {
        length = 13;
      }
      if (element.offsetWidth < 1000) {
        length = 9;
      }
      if (element.offsetWidth < 500) {
        length = 7;
      }
      if (element.offsetWidth < 300) {
        length = 5;
      }
      if (element.offsetWidth < 200) {
        length = 3;
      }
      reRender = reRender || (element.offsetWidth > 0 && this.pagingOldOffset !== element.offsetWidth);
    }
    if (!this.paging) {
      return;
    }
    reRender = reRender || this.pagingAactualPage !== this.paging.pagingPage || this.paging !== this.pagingInstace;
    if (!reRender) {
      return this.paginator;
    }
    if (element) {
      this.pagingOldOffset = element.offsetWidth;
    }
    this.pagingInstace = this.paging;
    this.pagingAactualPage = this.paging.pagingPage;
    let paginatorItems: any[] = [];
    const maxLength: number = (!length) ? 9 : length;
    if (maxLength < 5) {
      paginatorItems.push({label: '<', value: this.paging.pagingPage === 1 ? 1 : this.paging.pagingPage - 1});
      paginatorItems.push({label: this.paging.pagingPage, value: this.paging.pagingPage});
      paginatorItems.push({
        label: '>',
        value: this.paging.pagingPage === this.paging.pagingTotalPages ? this.paging.pagingTotalPages : this.paging.pagingPage + 1
      });
      this.paginator = paginatorItems;
      return paginatorItems;
    }

    let minDots;
    let maxDots;
    const middleNumbers = [];
    for (let i: any = 2; i < this.paging.pagingTotalPages; i++) {

      if (this.paging.pagingPage <= (maxLength + 1) / 2 && i < this.paging.pagingPage) {
        middleNumbers.push({label: i, value: i});
      } else if ((this.paging.pagingPage <= maxLength - 4 && i > this.paging.pagingPage
        && i < (maxLength - 1)) || this.paging.pagingTotalPages === maxLength) {
        middleNumbers.push({label: i, value: i});
      } else if (this.paging.pagingPage > this.paging.pagingTotalPages - (maxLength + 1) / 2 && i > this.paging.pagingPage) {
        middleNumbers.push({label: i, value: i});
      } else if (this.paging.pagingPage > this.paging.pagingTotalPages - maxLength - 4
        && i < this.paging.pagingPage && i > this.paging.pagingTotalPages - (maxLength - 2)) {
        middleNumbers.push({label: i, value: i});
      } else if (this.paging.pagingPage - i >= ((maxLength - 3) / 2)) {
        minDots = {label: '...', value: (i - ((maxLength - 5) / 2) < 2) ? 2 : i - ((maxLength - 5) / 2)};
      } else if (this.paging.pagingPage - i <= -1 * ((maxLength - 3) / 2)) {
        maxDots = maxDots || {
          label: '...',
          value: (i + ((maxLength - 5) / 2)) > this.paging.pagingTotalPages - 1
            ? this.paging.pagingTotalPages - 1
            : i + ((maxLength - 5) / 2)
        };
      } else {
        if ((this.paging.pagingPage - i > ((maxLength - 3) / 2)) || (this.paging.pagingPage - i < ((maxLength - 3) / 2))) {
          middleNumbers.push({label: i, value: i});
        }
      }
    }

    if (this.paging.pagingTotalPages > 0) {
      paginatorItems.push({label: '1', value: 1});
    }
    if (minDots) {
      paginatorItems.push(minDots);
    }

    // if(middleNumbers.length < (maxLength - 3) )

    paginatorItems = paginatorItems.concat(middleNumbers);

    if (maxDots) {
      paginatorItems.push(maxDots);
    }

    if (this.paging.pagingTotalPages > 1) {
      paginatorItems.push({label: this.paging.pagingTotalPages, value: this.paging.pagingTotalPages});
    }
    this.paginator = paginatorItems;
    return paginatorItems;
  }
  getMonthIconInner(data: any) {
    if (data.includes('SC')) {
      return 'fa-mobile';
    } else if (data.includes('FC')) {
      return 'fa-user-secret';
    }
    return '';
  }

  /** Ermittelt Audit-Status für Soll-Ist-Abgleich */
  getAuditStatus(row: any, month: string): string {
    const audits = row[month];
    if (!audits || audits.length === 0) return 'Keine Audits';
    if (audits.some((a: any) => a.stat === 'EXPIRED')) return 'Überfällig';
    if (audits.some((a: any) => a.stat === 'PLANNED')) return 'Geplant';
    if (audits.some((a: any) => a.stat === 'INPROG')) return 'In Arbeit';
    if (audits.some((a: any) => a.stat === 'DONE')) return 'Erledigt';
    return 'OK';
  }

  /** Gibt Klassen für Soll-Ist-Abgleich zurück */
  getSollIstClass(soll: number, ist: number): string {
    if (soll === ist) return 'th-success';
    if (ist < soll) return 'th-warning';
    if (ist > soll) return 'th-danger';
    return '';
  }

  /** Tooltip um Soll/Ist ergänzt */
  // getTooltip(x, col) {
  //   let base = super.getTooltip ? super.getTooltip(x, col) : '';
  //   const status = this.getAuditStatus(x, col);
  //   return (base || '') + `\nSoll: ${x.Soll} | Ist: ${x.Bestand} | Status: ${status}`;
  // }

  /** MonthStyle mit Statusfarben ergänzt */
  // getMonthStyle(isPrimary: boolean, pref: string, x: any, col: string) {
  //   const baseStyle = super.getMonthStyle
  //     ? super.getMonthStyle(isPrimary, pref, x, col)
  //     : {};
  //
  //   const status = this.getAuditStatus(x, col);
  //   let bg = null;
  //   switch (status) {
  //     case 'OK': bg = '#a3e6a1'; break;
  //     case 'Geplant': bg = '#ffd27f'; break;
  //     case 'Überfällig': bg = '#f77'; break;
  //     case 'In Arbeit': bg = '#88c8e0'; break;
  //     case 'Erledigt': bg = '#3bb538'; break;
  //   }

  //   return {
  //     ...baseStyle,
  //     backgroundColor: bg || baseStyle['backgroundColor']
  //   };
  // }

  /** Zählt pro Zeile alle Audits im Jahr (außer storniert) = Ist */
  private computeIst(row: any): number {
    let ist = 0;
    for (const m of Object.keys(this.colMonthMatch)) {
      const arr = row[m] as any[] || [];
      for (const a of arr) {
        // auftr_status 10 = Cancelled → nicht zählen
        if (a && a.auftr_status !== 10) {
          ist += 1;
        }
      }
    }
    return ist;
  }

  /** Ermittelt Soll/ Ist aus der Zeile – 'Soll' = AuditsPerYear (Fallbacks erlaubt) */
  // getSollIst(row: any): { soll: number, ist: number } {
  //   const soll = (row.AuditsPerYear ? row.Soll ? 0) ;
  //   const ist  = this.computeIst(row);
  //   return { soll, ist };
  // }

  // /** Liefert eine CSS-Klasse für Farblogik */
  // getSollIstClass(soll: number, ist: number): string[] {
  //   if (soll === ist) { return ['th-success']; }
  //   if (ist < soll)   { return ['th-danger']; }
  //   // ist > soll
  //   return ['th-warning'];
  // }

  getMonthName(index): string {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return months[index - 1];
  }
}
